import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {
  InlineFilter,
  InlineFilterProps,
} from '../../../../features/Filters/InlineFilter/InlineFilter';
import {InlineFilterError} from '../../../../features/Filters/InlineFilter/InlineFilterError';
import {InlineFilterLoading} from '../../../../features/Filters/InlineFilter/InlineFilterLoading';
import {useCategoryStreamFiltersData} from '../shared/useCategoryStreamFiltersData';

export const CategoryInlineFilter: React.FC<InlineFilterProps> = props => (
  <DataFetcher
    request={useCategoryStreamFiltersData()}
    Error={InlineFilterError}
    Loading={InlineFilterLoading}
    View={viewProps => (
      <InlineFilter showPersonalizedFilters={true} {...viewProps} />
    )}
    viewProps={props}
  />
);
